import React from "react";
import { IoCheckmark } from "react-icons/io5";

const SelectUtility = ({ setScreen, country, utility, setUtility }: any) => {
  const utilityList = [
    { id: 1, name: "Utility Bill" },
    { id: 2, name: "Recent Nepa Bill/Receipt" },
    { id: 3, name: "Meter Number" },
  ];

  return (
    <div className="w-full font-manrope">
      {/* Progress Steps */}
      <div className="flex w-full gap-2 justify-start items-center">
        <div className="w-[24px] h-[24px] rounded-full bg-[#0B6F18] font-sora text-white text-[10px] flex justify-center items-center">
          <IoCheckmark />
        </div>
        <div className="w-[24px] h-[24px] rounded-full border-[0.5px] border-[#0B75C2] bg-[#E9F1FF]  font-sora text-secondary_button text-[10px] flex justify-center items-center">
          2
        </div>
        <h4 className="text-[12px] text-black dark:text-white font-sora font-bold">
          Proof of Address
        </h4>
        <div className="bg-[#E5E7EB] dark:bg-gray-500 w-[2px] h-4 rounded-full"></div>

        <div className="w-[24px] h-[24px] rounded-full bg-[#EBEBEB] font-sora text-gray-600 dark:text-gray-400 dark:bg-gray-600 text-[10px] flex justify-center items-center">
          3
        </div>
      </div>

      {/* Title */}
      <div className="w-full mt-10">
        <h4 className="text-black dark:text-white text-center font-semibold font-sora text-[16px]">
          Select a utility bill to submit
        </h4>
        <h4 className="text-gray-400 text-center font-medium text-[12px]">
          Country: {country}
        </h4>

        {/* Document Selection */}
        <div className="mt-6 w-full">
          {utilityList.map((util) => (
            <div
              key={util.id}
              className="w-full flex justify-start items-center gap-3 py-2"
            >
              <input
                type="radio"
                value={util.name}
                checked={utility === util.name}
                onChange={(e) => setUtility(e.target.value)}
                className="w-[14px] h-[14px] bg-transparent rounded-full"
              />
              <h4 className="text-gray-500 dark:text-gray-400 text-[18px]">
                {util.name}
              </h4>
            </div>
          ))}
        </div>
      </div>
      <h4 className="text-gray-400 px-4 xs:px-6 mt-4 text-center text-[12px]">
        Make sure the name on the bill match with your profile details for
        successful verification.
      </h4>

      {/* Next Button */}
      <button
        disabled={!utility}
        onClick={() => setScreen(6)}
        className={
          !utility
            ? "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-gray-200 rounded-xl bg-gray-400"
            : "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
        }
      >
        Next
      </button>
    </div>
  );
};

export default SelectUtility;
